import React, { useEffect, useState } from 'react';
import { VersaoAppService } from '../../../services/versaoAppService';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { BaSeDialogContext } from '@base/react';
import { FaCheckCircle } from 'react-icons/fa';
import { AiFillExclamationCircle } from 'react-icons/ai';
import {
  ColumnGap,
  FlexDirectionWrapper,
  MainContent,
  SubTitle,
  Text,
  WrapperLegend,
} from '../../../../../components/StyledComponents';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { formatCPF, removeEmpty } from '../../../../../utils/utils';
import { VinculoEmpresaService } from '../../../services/VinculoEmpresa';
import { cnpjMask } from '../../../../../utils/mask';
import { numberLocale } from '../../../../../utils/mask';

export const GerenciarSolicitacaoVinculo = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [inputSearchValue, setInputSearchValue] = useState(null);
  const [paginationFilters, setPaginationFilters] = useState({
    page: 0,
    linesPerPage: 10,
    orderBy: 'dataCriacao',
    direction: 'DESC',
  });

  const getData = async (source) => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    const response = await VinculoEmpresaService.findAll(
      paginationFilters,
      bodyParams,
      source
    );
    setIsLoading(false);
    setData(response);
  };

  const getFilterOptionsData = async () => {
    setFilterOptions({});
    console.log(filterOptions);
    const response = await VersaoAppService.getFilterOptions();
    setFilterOptions(response);
  };

  const changeVinculoEmpresa = async (version) => {
    const associar = VinculoEmpresaService.associar(
      version.administrador.cpf,
      version.empreendedor.cnpj,
      version.relacao
    );

    const desassociar = VinculoEmpresaService.desassociar(
      version.administrador.cpf,
      version.empreendedor.cnpj
    );

    if (!!version.pendente) {
      return await desassociar;
    } else return await associar;
  };

  const onLinesPerPageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      linesPerPage: value,
      page: 0,
    });
  };

  const handlePageChange = (value) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: value,
    });
  };

  const handleOrderClick = ({ orderBy, direction }) => {
    setPaginationFilters({
      ...paginationFilters,
      orderBy: orderBy,
      direction: direction,
    });
  };

  const handleInputPageChange = (newValue) => {
    setIsLoading(true);
    setPaginationFilters({
      ...paginationFilters,
      page: newValue,
    });
  };

  const handleFilterByStatus = (status) => {
    setIsLoading(true);
    if (JSON.stringify(status) === JSON.stringify(filters?.pendente)) {
      setFilters((f) => ({ ...f, pendente: null }));
      return;
    }
    setFilters((f) => ({ ...f, pendente: status }));
    setPaginationFilters({
      ...paginationFilters,
      page: 0,
    });
  };

  const handleVinculoClick = (item) => {
    handleModalAdmin({
      title: `${!item.pendente ? 'Vincular' : 'Desvincular'} empresa`,
      content: `Você pode alterar o vínculo da empresa. Escolha uma das opções abaixo`,
      msgOnSuccess: `O status do vinculo foi ${
        !item.pendente ? 'Desaprovado' : 'Aprovado'
      } com sucesso`,
      msgOnError: `O status do vinculo não foi ${
        !item.pendente ? 'Desaprovado' : 'Aprovado'
      } Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: () => changeVinculoEmpresa(item),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    setData([]);
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, filters, inputSearchValue]);

  useEffect(() => {
    getFilterOptionsData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableColumns = [
    {
      field: 'dataCriacao',
      id: 'dataCriacao',
      label: 'Data',
      minWidth: 10,
    },
    {
      field: 'administrador',
      subfield: 'cpf',
      id: 'administrador',
      label: 'CPF_SOLICITANTE',
      minWidth: 100,
      align: 'left',
      handleField: formatCPF,
    },
    {
      field: 'empreendedor',
      subfield: 'cnpj',
      id: 'empreendedor',
      label: 'CNPJ_Empresa',
      minWidth: 100,
      align: 'left',
      handleField: cnpjMask,
    },
    {
      field: 'actions',
      id: 'actions',
      label: 'Status',
      minWidth: 50,
      align: 'left',
    },
  ];

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
          />
        </>
      </SubTitle>

      <WrapperLegend>
        <ColumnGap gap="7px" padding="6px 10px"></ColumnGap>

        <FlexDirectionWrapper>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => handleFilterByStatus(true)}
          >
            <AiFillExclamationCircle size={25} color="#F6E566" />
            <Text margin="4px" color="#B3B3B3">
              Vínculo pendente
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => handleFilterByStatus(false)}
          >
            <FaCheckCircle size={25} color="#66BD91" />
            <Text margin="4px" color="#B3B3B3">
              Vínculo aceito
            </Text>
          </div>
        </FlexDirectionWrapper>
      </WrapperLegend>

      <FlexDirectionWrapper
        style={{ justifyContent: 'space-between', marginTop: '12px' }}
      >
        <div>
          <p style={{ fontWeight: 'bold', color: '#0061C6' }}>
            {numberLocale(data?.totalElements)}{' '}
            <strong className="find-results"> resultados encontrados </strong>
          </p>
        </div>
      </FlexDirectionWrapper>

      <TableAdmin
        data={data}
        columnAction={'actions'}
        paginationFilters={paginationFilters}
        linesPerPageFilters={paginationFilters?.linesPerPage}
        pagination={true}
        totalPages={data?.totalPages}
        columns={tableColumns}
        isLoading={isLoading}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        onLinesPerPageChange={onLinesPerPageChange}
        onPagePreviousChange={handlePageChange}
        onPageNextChange={handlePageChange}
        handleOrderClick={handleOrderClick}
        onInputPageChange={handleInputPageChange}
        handleVinculoClick={handleVinculoClick}
      />
    </MainContent>
  );
};
